export enum QuantityCheckMethodEnum {
  MANUAL = 'manual',
  BARCODE = 'barcode',
  SERIAL_NUMBER = 'serial_number',
}
